import React, { useMemo } from "react";
import ReportCalendar from "./ReportCalendar";
import getAllTeamMembersPromise from "./getTeamMembers";
import { useState } from "react";
import { useEffect } from "react";
import { LoadingIndicator, SingleSelect, TwoSwitch } from "../../lib/iprs-react-library/src/index.js";
import getEventSource from "./EventSource";
import TableAvailabilityView from "./TableAvailabilityView";
import TableChargeableView from "./TableChargeableView";

const viewConsts = {
    Calendar:               'Calendar',
    TableAvailabilityView:  'Table Availability View',
    TableChargeableView:    'Table Chargeable View'
};

/**
 * The main component of the reporting section 
 */
const Report = ({api,state}) => {

    const [error, setError]                     = useState('');
    const [clinicians, setClinicians]           = useState([]);
    const [cliniciansByID, setCliniciansByID]   = useState([]);

    const [loading, setLoading]                 = useState(true);

    useEffect(() => { 

        setLoading(true);

        const teamIDs       = state.team?.teams?.map(t=>t.pkTeamId);
        getAllTeamMembersPromise(api, teamIDs)
        .then( c => {
            setClinicians(c.clinicians);
            setCliniciansByID(c.cliniciansByID);
            setLoading(false);
        } )
        .catch( e => { 
            setError(e.message); 
            setLoading(false); 
        } );

        const monthAhead    = dateAdd(today, 30);
        setStartDate(today);  
        setFinishDate(monthAhead);  
    }, [api, state.team?.teams] );

    const appointmentTypes = useMemo(() => state.appType?.appointmentTypes,[state]);

    const [selectedAppointmentTypeID, setSelectedAppointmentTypeID] = useState(0);
    const [view, setView]                                           = useState(viewConsts.TableAvailabilityView);

    const [events, setEvents]                                       = useState([]);

    const [startDate,  setStartDate]                     = useState(today);
    const [finishDate, setFinishDate]                    = useState(today);

    let viewComp;
    switch (view) {

        case viewConsts.TableChargeableView:
            viewComp = <TableChargeableView api={api} clinicians={clinicians} events={events} setError={setError} />;
            break;
        case viewConsts.TableAvailabilityView:
            viewComp = <TableAvailabilityView clinicians={clinicians} events={events} />;
            break;
        case viewConsts.Calendar:
        default:
            viewComp = <ReportCalendar clinicians={clinicians} startDate={startDate} finishDate={finishDate} events={events} />;
    }

    useEffect( () =>{
        const newDates = {startDate, finishDate};
        
        if(0!==selectedAppointmentTypeID){
        
            setError('');
            setLoading(true);

            getEventSource(api, cliniciansByID, selectedAppointmentTypeID, newDates)
            .then(evs => { 
                setError('');
                setEvents(evs); 
                setLoading(false); 
            })
            .catch(e => {
                setError(e.message); 
                setLoading(false);}
            );
        }
        
    }, [startDate, finishDate, api, clinicians, selectedAppointmentTypeID, cliniciansByID] );

    return <div>
        <h1>Reporting</h1>
        <div style={{ float: 'left', clear: 'right' }}>
            <div style={{ float: 'left', clear: 'right' }}>
                <label htmlFor="selectAppType">Select Appointment Type</label>
                <SingleSelect
                    selectableItems={[{ AppointmentTypeID: 0, Title: 'Select' }, ...appointmentTypes]}
                    selectedItem={selectedAppointmentTypeID}
                    setSelectedItem={setSelectedAppointmentTypeID}
                    getItemID={a => a.AppointmentTypeID}
                    getItemTitle={a => a.Title}
                    name='selectAppType' />
            </div>
            <div style={{ float: 'left', clear: 'right', width: '100%', marginTop: '1em' }} >
                <fieldset style={{marginTop: '1em'}}>
                    <legend>Report Dates</legend>
                    <div style={{float: 'left', marginRight: '1em'}}>
                        <label htmlFor="startDate">Start Date</label>
                        <input type='date' id='startDate'  name='startDate'     value={startDate}  onChange={e=>setStartDate(e.target.value)} />
                    </div>
                    <div style={{float: 'left'}}>
                        <label htmlFor="finishDate">Finish Date</label>
                        <input type='date' id='finishDate'  name='finishDate'   value={finishDate}  onChange={e=>setFinishDate(e.target.value)} />
                    </div>
                </fieldset>
            </div>
            <div style={{ float: 'left', clear: 'right', width: '100%', marginTop: '3em' }} >
                <label htmlFor='view' >Select A View</label>
                <select id='view' value={view} onChange={e => setView(e.target.value)}>
                    <option>{viewConsts.TableAvailabilityView}</option>
                    <option>{viewConsts.TableChargeableView}</option>
                    <option>{viewConsts.Calendar}</option>
                </select>
            </div>
        </div>
        <div>
        </div>
        <div style={{ float: 'left', clear: 'right', width: '100%', marginTop: '3em' }}>
            <TwoSwitch test={error}>
                <p>{error}</p>
                <TwoSwitch test={loading} >
                    <LoadingIndicator loading={true} />
                    {viewComp}
                </TwoSwitch>
            </TwoSwitch>
        </div>
    </div>
}

const today         = new Date().toISOString().substring(0,10);

const dateAdd = (date, numberOfDays) => {
    const newFinishDate = new Date(date);
    newFinishDate.setDate(newFinishDate.getDate() + numberOfDays);

    return newFinishDate.toISOString().substring(0,10);
}

export default Report;